module.exports = __webpack_public_path__ + "static/img/product-not-found.14b4f54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-not-found.svg
// module id = yMOD
// module chunks = 1